<template>
  <div :class="classes">
    <div class="trbo-a-notification__wrapper">
      <div class="trbo-a-notification__text">
        {{ message }}
      </div>
      <div class="trbo-a-notification__close" @click="handleClose">
        <icon name="close" class="trbo-a-notification__close__icon" />
      </div>
    </div>
  </div>
</template>

<script>
// @flow

import Icon from '../Icon/Icon.vue'

export default {
  components: {
    Icon
  },
  props: {
    message: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    timeout: {
      type: Number,
      default: 5000
    }
  },
  data () {
    return {
      isLeaving: false
    }
  },
  computed: {
    classes () {
      return {
        'trbo-a-notification': true,
        'trbo-a-notification--error': this.type === 'error',
        'trbo-a-notification--is-leaving': this.isLeaving
      }
    }
  },
  created () {
    this.interval = setTimeout(() => {
      this.handleClose()
    }, this.timeout)
  },
  destroyed () {
    clearInterval(this.timeout)
  },
  methods: {
    handleClose () {
      this.isLeaving = true
      this.interval = setTimeout(() => {
        this.$emit('close')
      }, 200)
    }
  }
}
</script>

<style scoped src="./notification.scss" />
